module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/Kxh6KO/tc-custom/9780830884292.jpg?1696025499531",
      "alt": "This image is the cover for the book Story-Shaped Worship"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Story-Shaped Worship\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("What is the right way to worship? Right worship does not require a return to the identical forms found in the early church or later in Rome or after that in Westminster. What it calls for is a faithful response today to the God of our salvation in light of those biblically ordered and historically informed patterns. In this study Robbie Castleman uncovers the fundamental shape of worship. What she unearths is a shape that is outlined in Scripture, enacted in Israel, refocused in the New Testament community, regulated and guarded by the Apostolic fathers, and recovered in the Reformation. It is a worship that can and does still shape the liturgy of many congregations today.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Robbie F. Castleman\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }), _c('p', [_vm._v("Robbie F. Castleman (D.Min., University of Dubuque) is professor of biblical studies and theology at John Brown University in Siloam Springs, Arkansas. She previously served for several years as a staff member with InterVarsity Christian Fellowship, specializing in ministry to graduate students at campuses in and around Tallahassee, Florida. She is the author of the Fisherman Bible Guides"), _c('em', [_vm._v("Miracles, Elijah, David and King David")]), _vm._v(" (Shaw/Waterbrook) and the IVP Connect LifeGuide Bible Study "), _c('em', [_vm._v("Peter,")]), _vm._v(" and she is a contributor to the book "), _c('em', [_vm._v("For All the Saints")]), _vm._v(" (Knox/Westminster).")]), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    InterVarsity Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0